import React, { useState, useEffect } from 'react';
import { Typography, Steps, Skeleton } from 'antd';
import get from 'lodash/get';
import assign from 'lodash/assign';
import { useDispatch } from 'react-redux';
import { matchPath, useHistory, useParams } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import ContentPageHeader from '../../../components/contentPageHeader';
import { EDIT_OFFERINGS } from '../../../constants/routes';
import SelectSalesChannel from './SelectSalesChannel';
import SelectProduct from './SelectProduct';
import OfferingDetails from './OfferingDetails';
import OtherInfo from './OtherInfo';
import OfferingFinalDetails from './OfferingFinalDetails';
import { offeringManagement } from '../../../redux/actions/offeringAction';
import { generateInitialEditpaylod } from '../../../utilities/offering';

const { Text } = Typography;

const CreateOfferingScreen = () => {
  const history = useHistory();
  const { companyId, id } = useParams();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const [payload, setPayload] = useState({
    step: 0,
    step1: null,
    step2: null,
    step3: null,
    step4: null,
  });

  const edit = !!matchPath(history.location.pathname, {
    path: EDIT_OFFERINGS,
    exact: true,
  });

  const onSubmitPayload = (currentStep, obj = {}) => {
    let key = null;
    switch (currentStep) {
      case 0:
        key = 'step1';
        break;
      case 1:
        key = 'step2';
        break;
      case 2:
        key = 'step3';
        break;
      case 3:
        key = 'step4';
        break;
      default:
        key = null;
        break;
    }
    assign(payload, { [key]: obj, step: currentStep + 1 });
    setPayload({ ...payload });
  };

  const onMove = (step) => {
    setPayload({ ...payload, step });
  };

  const fetchOfferingDetails = () => {
    setLoading(true);
    dispatch(
      offeringManagement('get.offering', {
        id: parseInt(id),
        company_id: parseInt(companyId),
      })
    )
      .then((result) => {
        const editPayload = generateInitialEditpaylod(get(result, 'data'));
        setPayload(editPayload);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (edit) {
      fetchOfferingDetails();
    }
  }, []);

  return (
    <div>
      <div>
        <ContentPageHeader
          title={[
            <Text className="content-page-header-heading">Product</Text>,
            <RightOutlined className="content-page-header-heading" />,
            <Text className="content-page-header-heading">Offerings</Text>,
            <RightOutlined className="content-page-header-heading" />,
            <Text className="content-page-header-heading">
              {edit ? 'Edit Offering Details' : 'Add New Offering'}
            </Text>,
          ]}
          extra={[]}
        />
        <div className="create-product-stepper">
          <Steps
            labelPlacement="vertical"
            size="small"
            current={get(payload, 'step')}
            onChange={(value) => {
              setPayload({
                ...payload,
                step:
                  get(payload, 'step') > value ? value : get(payload, 'step'),
              });
            }}
            items={[
              {
                title: 'Select Sales Channel',
              },
              {
                title: 'Product Selection',
              },
              {
                title: 'Offering Details',
              },
              {
                title: 'Other Necessary Information',
              },
              {
                title: 'Final Confirmation',
              },
            ]}
          />
        </div>
        <div className="create-product-form-container">
          <Skeleton loading={loading}>
            {get(payload, 'step') === 0 && (
              <SelectSalesChannel
                edit={edit}
                onSubmitPayload={onSubmitPayload}
                initialValues={get(payload, 'step1')}
              />
            )}
            {get(payload, 'step') === 1 && (
              <SelectProduct
                edit={edit}
                onMove={onMove}
                onSubmitPayload={onSubmitPayload}
                initialValues={get(payload, 'step2')}
              />
            )}
            {get(payload, 'step') === 2 && (
              <OfferingDetails
                edit={edit}
                onMove={onMove}
                onSubmitPayload={onSubmitPayload}
                initialValues={get(payload, 'step3')}
                selectProducts={get(payload, 'step2')}
              />
            )}
            {get(payload, 'step') === 3 && (
              <OtherInfo
                onMove={onMove}
                onSubmitPayload={onSubmitPayload}
                initialValues={get(payload, 'step4')}
              />
            )}

            {get(payload, 'step') === 4 && (
              <OfferingFinalDetails
                edit={edit}
                onMove={onMove}
                onSubmitPayload={onSubmitPayload}
                details={payload}
                id={id}
                companyId={companyId}
              />
            )}
          </Skeleton>
        </div>
      </div>
    </div>
  );
};

export default CreateOfferingScreen;
